<template>
  <div class="content">
    <Information :url="img" :title="title" :api="api"/>
  </div>
</template>
<script>
import Information from '@/components/Information4'
export default {
  components: {
    Information
  },
  data() {
    return {
      img: 'images/weiyuanhui_image.jpg',
      title: '组织机构',
      api: 'get_mechanism'
    }
  },
}
</script>
